export enum GraphhopperCacheType {
    GEOCODING = 0,
    ROUTING = 1,
    OPTIMIZATION = 2,
    CLUSTER = 3
}